var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoleculeAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "71px",
    height: "71px",
    viewBox: "0 0 71 71",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C7EDED7C-67AF-4A69-9FEC-3304264065F1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7---Warnings-and-precautions-for-Hana-",
    transform: "translate(-75.000000, -179.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(77.000000, 181.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.77755,25.202655 C37.13265,25.202655 38.2311,26.301105 38.2311,27.656205 C38.2311,29.011455 37.13265,30.109905 35.77755,30.109905 C34.42245,30.109905 33.324,29.011455 33.324,27.656205 C33.324,26.301105 34.42245,25.202655 35.77755,25.202655 Z",
    id: "Stroke-1",
    stroke: "#EE7330",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.80438,37.688265 C33.47568,37.003665 35.38563,37.803315 36.07038,39.474465 C36.75513,41.145915 35.95548,43.055715 34.28418,43.740615 C32.61288,44.425365 30.70293,43.625565 30.01818,41.954265 C29.33343,40.283115 30.13308,38.373015 31.80438,37.688265 Z",
    id: "Stroke-3",
    stroke: "#EE7330",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.287885,18.763065 L27.532635,21.139065 L21.593385,18.480165 C19.815285,17.594265 17.819985,19.404465 18.618285,21.280515 L21.130935,27.156465 L8.365935,31.461015 C6.387435,32.125065 6.395085,34.957065 8.399235,35.593215 L21.332385,39.703965 L18.673485,45.643365 C17.787585,47.421465 19.597785,49.416615 21.473835,48.618465 L27.349785,46.105815 L31.654335,58.870815 C32.318385,60.849315 35.150385,60.841665 35.786385,58.837515 L39.897285,45.904215 L45.836535,48.563115 C47.614635,49.449015 49.609785,47.638815 48.811635,45.762765 L46.298985,39.886815 L48.052485,39.295515 M59.063985,35.582265 C61.042485,34.918215 61.034835,32.086215 59.030835,31.450215 L46.097535,27.339465 L48.756435,21.400065 C49.642485,19.622115 47.831985,17.626815 45.956085,18.424815 L40.079985,20.937465 L35.775585,8.172465 C35.111535,6.193965 32.279535,6.201615 31.643535,8.205765",
    id: "Stroke-5",
    stroke: "#222456",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.75311,28.179225 C25.75311,28.781625 26.24136,29.269875 26.84361,29.269875 L26.84436,29.269875 C27.44661,29.269875 27.93456,28.781625 27.93456,28.179225 C27.93456,27.576975 27.44586,27.088725 26.84361,27.088725 C26.24136,27.088725 25.75311,27.576975 25.75311,28.179225",
    id: "Fill-7",
    fill: "#EE7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.393425,34.804125 C43.995675,34.804125 44.483625,34.315875 44.483625,33.713625 C44.483625,33.111375 43.994925,32.623125 43.392675,32.623125 C42.790425,32.623125 42.302175,33.111375 42.302175,33.713625 C42.302175,34.315875 42.790425,34.804125 43.392675,34.804125 L43.393425,34.804125 Z",
    id: "Fill-9",
    fill: "#EE7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.25224,32.077905 C29.64999,32.077905 29.16174,32.566155 29.16174,33.168405 C29.16174,33.770655 29.64999,34.258905 30.25224,34.258905 L30.25299,34.258905 C30.85539,34.258905 31.34319,33.770655 31.34319,33.168405 C31.34319,32.566155 30.85449,32.077905 30.25224,32.077905",
    id: "Fill-11",
    fill: "#EE7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.965685,33.931665 C18.965685,34.534065 19.453935,35.022315 20.056185,35.022315 L20.056935,35.022315 C20.659185,35.022315 21.146985,34.534065 21.146985,33.931665 C21.146985,33.329415 20.658435,32.841165 20.056185,32.841165 C19.453935,32.841165 18.965685,33.329415 18.965685,33.931665",
    id: "Fill-13",
    fill: "#EE7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.210955,42.110475 L41.211705,42.110475 C41.813955,42.110475 42.301755,41.622225 42.301755,41.019825 C42.301755,40.417725 41.813205,39.929475 41.210955,39.929475 C40.608705,39.929475 40.120455,40.417725 40.120455,41.019825 C40.120455,41.622225 40.608705,42.110475 41.210955,42.110475",
    id: "Fill-15",
    fill: "#EE7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.62404,50.289135 C32.62404,50.891385 33.11229,51.379635 33.71454,51.379635 L33.71529,51.379635 C34.31769,51.379635 34.80549,50.891385 34.80549,50.289135 C34.80549,49.686735 34.31679,49.198485 33.71454,49.198485 C33.11229,49.198485 32.62404,49.686735 32.62404,50.289135",
    id: "Fill-17",
    fill: "#EE7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.58888,15.762915 C30.19113,15.762915 30.67938,15.274665 30.67938,14.672415 C30.67938,14.070165 30.19113,13.581915 29.58888,13.581915 L29.58813,13.581915 C28.98588,13.581915 28.49808,14.070165 28.49808,14.672415 C28.49808,15.274665 28.98663,15.762915 29.58888,15.762915",
    id: "Fill-19",
    fill: "#EE7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.68171,36.643965 L52.68081,36.643965 C52.07856,36.643965 51.59076,37.132215 51.59076,37.734615 C51.59076,38.336715 52.07946,38.824965 52.68171,38.824965 C53.28396,38.824965 53.77221,38.336715 53.77221,37.734615 C53.77221,37.132215 53.28381,36.643965 52.68171,36.643965",
    id: "Fill-21",
    fill: "#EE7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.78486,29.39505 C69.06396,47.76585 56.01906,64.50585 37.64826,66.78495 C19.27761,69.06405 2.53761,56.019 0.25851,37.6482 C-2.02059,19.27755 11.02431,2.53755 29.39511,0.2586 C47.76591,-2.0205 64.50576,11.02425 66.78486,29.39505 Z",
    id: "Stroke-23",
    stroke: "#222456",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoleculeAlt);
export default __webpack_public_path__ + "static/media/moleculeAlt.ca73f423.svg";
export { ForwardRef as ReactComponent };